export default __webpack_public_path__ + "static/linkedin-65f9635fde24a859e0484c5fde0fac49.svg";